import I18n from 'I18n';
import { SavedDashboardFilterSetFrequency } from '../../../../lib/savedDashboardFilters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useSelector } from 'react-redux';
import { RelationalReport } from 'reporting-snowflake/relational/schema/report-records';
import { hasReportDefinition, getReportDefinition
// @ts-expect-error migrate dependency
} from 'dashboard-lib/public/report/report-schema';
import { selectDashboardFrequency, selectDashboardFrequencyUseFiscalYear } from '../../../../ducks/applied-dashboard-filters';
import { canOverrideReportDefinitionsFrequency } from '../../../../lib/dashboardFilters/snowflake-frequency-override-utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DashboardFiltersFrequencyText = props => {
  const {
    frequency,
    useFiscalYear = false
  } = props;
  if (!frequency) {
    return null;
  }
  const unit = (() => {
    if (useFiscalYear && (frequency === SavedDashboardFilterSetFrequency.YEAR || frequency === SavedDashboardFilterSetFrequency.QUARTER)) {
      return I18n.text(`frequencyControl.frequencyDescription.units.FISCAL_${frequency}`);
    }
    return I18n.text(`frequencyControl.frequencyDescription.units.${frequency}`);
  })();
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "frequencyControl.frequencyDescription.label",
    options: {
      unit
    }
  });
};
export const DashboardFiltersFrequencyDescription = props => {
  const {
    frequency,
    useFiscalYear = false
  } = props;
  if (!frequency) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frequencyControl.frequencyDescription.header"
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(DashboardFiltersFrequencyText, {
      frequency: frequency,
      useFiscalYear: useFiscalYear
    })]
  });
};
export const AppliedFrequencyToReportDescription = props => {
  const {
    dashboardId,
    report
  } = props;
  const appliedFrequency = useSelector(selectDashboardFrequency(dashboardId));
  const appliedFrequencyUseFiscalYear = useSelector(selectDashboardFrequencyUseFiscalYear(dashboardId));
  const isFrequencyOverridden = (() => {
    try {
      const isSnowflakeReport = hasReportDefinition(report);
      if (isSnowflakeReport) {
        const reportDefinition = RelationalReport(getReportDefinition(report));
        return canOverrideReportDefinitionsFrequency(reportDefinition, appliedFrequency, appliedFrequencyUseFiscalYear);
      }
      const configReportsFrequency = report.getIn(['config', 'frequency']);
      return appliedFrequency != null && configReportsFrequency != null && configReportsFrequency !== appliedFrequency;
    } catch (error) {
      return false;
    }
  })();
  if (!isFrequencyOverridden) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: "100",
    as: "div",
    children: [/*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frequencyControl.frequencyDescription.appliedToReportHeader"
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(DashboardFiltersFrequencyText, {
      frequency: appliedFrequency,
      useFiscalYear: appliedFrequencyUseFiscalYear
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export const AppliedDashboardFiltersFrequencyDescription = props => {
  const {
    dashboardId
  } = props;
  const appliedFrequency = useSelector(selectDashboardFrequency(dashboardId));
  const appliedFrequencyUseFiscalYear = useSelector(selectDashboardFrequencyUseFiscalYear(dashboardId));
  return /*#__PURE__*/_jsx(DashboardFiltersFrequencyDescription, {
    frequency: appliedFrequency,
    useFiscalYear: appliedFrequencyUseFiscalYear
  });
};